<template>
  <div class="authBackground" @mousedown="hideAuthBlock">
    <div class="authBlock">
      <div class="modalHeader">
        <img src="../assets/icons/logo.svg" />
        <div class="closeAuth" @click="closeModal">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 14L13.7279 1.27208" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round" />
            <path d="M1 1L13.7279 13.7279" stroke="#2F2F2F" stroke-width="2" stroke-linecap="round" />
          </svg>
        </div>
      </div>
      <div class="signSelector" :class="{ 'signSelector-sign-up': mode === 'signUpSelect' }">
        <div class="slider"></div>
        <p class="signInSelect" @click="changeMode('signInSelect')" :class="{ selectedSign: mode === 'signInSelect' }">Вход</p>
        <p class="signUpSelect" @click="changeMode('signUpSelect')" :class="{ selectedSign: mode === 'signUpSelect' }">Регистрация</p>
      </div>
      <Transition name="fade" mode="out-in">
        <component :is="currentComponent" @afterRegistration="afterReg"></component>
      </Transition>
      <!-- <LoginComponent v-if='mode === "signInSelect"'/>
			<RegisterComponent v-if='mode === "signUpSelect"'/> -->
    </div>
  </div>
</template>

<script>
import ErrorBlock from "./ErrorBlock.vue";
import LoginComponent from "./LoginComponent.vue";
import RegisterComponent from "./RegisterComponent.vue";

export default {
  name: "AuthComponent",
  props: { modeParent: String },
  data() {
    return {
      mode: this.normalizeMode(this.modeParent),
    };
  },
  computed: {
    currentComponent() {
      return this.mode === "signUpSelect" ? "RegisterComponent" : "LoginComponent";
    },
  },
  watch: {
    modeParent(newMode) {
      this.mode = this.normalizeMode(newMode);
    },
  },
  components: {
    LoginComponent,
    RegisterComponent,
    ErrorBlock,
  },
  methods: {
    normalizeMode(mode) {
      return mode === "signUpSelect" ? "signUpSelect" : "signInSelect";
    },
    changeMode(mode) {
      this.mode = this.normalizeMode(mode);
    },
    closeModal() {
      this.$emit("close-auth");
    },
    afterReg() {
      this.mode = "signInSelect";
    },
    hideAuthBlock(event) {
      let authBlock = document.querySelector(".authBlock");
      if (event.target.contains(authBlock) && event.target.className != "authBlock") this.closeModal();
    },
  },
};
</script>
<style scoped>
.authBackground {
  background-color: #232323e5;
  backdrop-filter: blur(8px);
  color: white;
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 5002;
  display: flex;
  align-items: center;
  justify-content: center;
}
.authBlock {
  width: 30vw;
  margin: 0 auto;
  border-radius: 10px;
  background-color: #ffffff;
  padding: 1% 2% 1% 2%;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: transform 0.3s ease, opacity 0.3s ease;
  overflow-y: clip;
  max-height: 99%;
}
.modalHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.closeAuth {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #2f2f2f;
  border-radius: 5px;
  padding: 2%;
  cursor: pointer;
}
.signSelector {
  background-color: #f6fafd;
  border-radius: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: center;
  padding: 5px;
  width: 100%;
  gap: 5px;
  color: #333333;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  height: 100%;
  position: relative;
  align-self: flex-start;
  margin-bottom: 20px;
  justify-items: center;
}
.signSelector p {
  position: relative;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  cursor: pointer;
  transform: color 0.8s;
  user-select: none;
  width: 100%;
  min-width: 0;
  white-space: nowrap;
}

.selectedSign {
  /* background-color: #2F2F2F; */
  color: #ffffff;
  border-radius: 10px;
}
.slider {
  position: absolute;
  top: 5px;
  bottom: 5px;
  left: 5px;
  width: calc((100% - 15px) / 2);
  background-color: #2f2f2f;
  border-radius: 10px;
  transition: transform 0.3s ease;
  z-index: 1; /* За текстом */
  pointer-events: none;
}
.signSelector-sign-up .slider {
  transform: translateX(calc(100% + 5px));
}
.auth-block.expand-fade-enter-active,
.auth-block.expand-fade-leave-active {
  transition: max-height 0.5s ease;
}

/* Скрытое состояние (0 высоты) */
.auth-block.expand-fade-enter, 
.auth-block.expand-fade-leave-to /* .expand-fade-leave-active в Vue 3.0+ */ {
  max-height: 0;
  opacity: 0;
}

/* Открытое состояние */
.auth-block.expand-fade-enter-to,
.auth-block.expand-fade-leave {
  max-height: 1000px; /* Значение, большее, чем максимальная высота компонента */
  opacity: 1;
}
@media (max-width: 968px) {
  .authBlock {
    width: 80vw;
    padding: 5% 7% 5% 7%;
  }
  .signInSelect,
  .signUpSelect {
    flex-grow: 1;
    padding: 2%;
  }
  .signSelector {
    width: 100%;
  }
}
</style>
